"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var USER_ERROR_GROUP = "User";
var APP_ERROR_GROUP = "Error";
var EDM_ERROR_GROUP = "EDM";
var UNKNOWN_ERROR_GROUP = "Unknown";

var markError = function markError(error, marker) {
  if (error && _typeof(error) === "object") {
    // eslint-disable-next-line no-param-reassign
    error.errorGroup = marker;
  }
};

var markUserError = function markUserError(error) {
  return markError(error, USER_ERROR_GROUP);
};

var markAppError = function markAppError(error) {
  return markError(error, APP_ERROR_GROUP);
};

var markEdmError = function markEdmError(error) {
  return markError(error, EDM_ERROR_GROUP);
};

var isUserError = function isUserError(error) {
  return error && error.errorGroup === USER_ERROR_GROUP;
};

var isAppError = function isAppError(error) {
  return error && error.errorGroup === APP_ERROR_GROUP;
};

var isEdmError = function isEdmError(error) {
  return error && error.errorGroup === EDM_ERROR_GROUP;
};

var isMarked = function isMarked(error) {
  if (!error) {
    return false;
  }

  return error.errorGroup !== undefined;
};

module.exports = {
  markUserError: markUserError,
  isUserError: isUserError,
  markAppError: markAppError,
  isAppError: isAppError,
  markEdmError: markEdmError,
  isEdmError: isEdmError,
  markError: markError,
  isMarked: isMarked,
  USER_ERROR_GROUP: USER_ERROR_GROUP,
  APP_ERROR_GROUP: APP_ERROR_GROUP,
  EDM_ERROR_GROUP: EDM_ERROR_GROUP,
  UNKNOWN_ERROR_GROUP: UNKNOWN_ERROR_GROUP
};